import { render, staticRenderFns } from "./EnvioInformacionTotal.vue?vue&type=template&id=68131eba"
import script from "./EnvioInformacionTotal.vue?vue&type=script&lang=js"
export * from "./EnvioInformacionTotal.vue?vue&type=script&lang=js"
import style0 from "./EnvioInformacionTotal.vue?vue&type=style&index=0&id=68131eba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports